import constants from "../../shared/constants";

function loading(state = false, action) {
  switch (action.type) {
    case constants.FILTER_LIST:
    case constants.FETCH_NEXT_LIST_TYPE:
    case constants.FETCH_LIST: {
      return true;
    }
    case constants.FILTER_LIST_DONE:
    case constants.FETCH_NEXT_LIST_TYPE_DONE:
    case constants.FETCH_LIST_DONE: {
      return false;
    }
    default: {
      return state;
    }
  }
}

export default loading;



// WEBPACK FOOTER //
// ./assets/pois/reducers/loading.js